import { FC } from "react";
import { Button } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { WXCC_ADDON_LABELS, formatAddOnCurrency, formatAddOnItemCount } from "constant/wxcc-addons";
import {
  AddOnGroup,
  AddOnTotals,
  getGroupTotal,
} from "components/summary/index/Revenue/addonBreakdown";
import WxccAddOnCategoryBadge from "./WxccAddOnCategoryBadge";

interface WxccAddOnPreviewProps {
  groups: AddOnGroup[];
  summaryTotals?: AddOnTotals;
  onViewAll: (category: AddOnGroup["category"]) => void;
}

const WxccAddOnPreview: FC<WxccAddOnPreviewProps> = ({ groups, summaryTotals, onViewAll }) => (
  <div onClick={(event) => event.stopPropagation()}>
    <div
      style={{
        background: "#F7F9FA",
        border: "1px solid #E1E6E9",
        borderRadius: 8,
        margin: "6px 0",
        overflow: "hidden",
        padding: "0 8px",
      }}
    >
      {groups.map((group, groupIndex) => {
        const groupTotal = summaryTotals?.[group.category] ?? getGroupTotal(group.items);

        return (
          <div
            key={group.category}
            style={{
              borderTop: groupIndex === 0 ? "none" : "1px solid #E1E6E9",
              padding: "10px 4px",
            }}
          >
            <div
              style={{
                alignItems: "center",
                display: "grid",
                gap: 8,
                gridTemplateColumns: "minmax(0, 1fr) auto",
                marginBottom: summaryTotals ? 0 : 6,
              }}
            >
              <div style={{ alignItems: "center", display: "flex", gap: 7 }}>
                <WxccAddOnCategoryBadge group={group} />
                {!summaryTotals && (
                  <span
                    style={{
                      color: "#70777A",
                      fontSize: 12,
                      lineHeight: "18px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {formatAddOnItemCount(group.items.length)}
                  </span>
                )}
              </div>
              <span
                style={{
                  color: "#333",
                  fontSize: 12,
                  lineHeight: "18px",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {formatAddOnCurrency(groupTotal)}
              </span>
            </div>
            {!summaryTotals &&
              group.items.slice(0, 2).map((item) => (
                <div
                  key={item.id}
                  style={{
                    alignItems: "start",
                    display: "grid",
                    gap: 12,
                    gridTemplateColumns: "minmax(0, 1fr) auto",
                    padding: "4px 0",
                  }}
                >
                  <span
                    style={{
                      color: "#535759",
                      fontSize: 12,
                      lineHeight: "18px",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {item.label}
                  </span>
                  <span
                    style={{
                      color: "#333",
                      fontSize: 12,
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {formatAddOnCurrency(item.value)}
                  </span>
                </div>
              ))}
            {!summaryTotals && group.items.length > 2 && (
              <Button
                endIcon={<ArrowForward style={{ fontSize: 14 }} />}
                onClick={() => onViewAll(group.category)}
                size="small"
                sx={{
                  fontSize: 12,
                  lineHeight: "18px",
                  fontWeight: 700,
                  display: "flex",
                  justifyContent: "flex-start",
                  minHeight: 0,
                  minWidth: 0,
                  mt: 0.75,
                  p: 0,
                  textTransform: "none",
                }}
              >
                {WXCC_ADDON_LABELS.viewAll} {formatAddOnItemCount(group.items.length)}
              </Button>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default WxccAddOnPreview;
